import { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";

const SEO = ({ page }) => {
  const { lang, t } = useLanguage();
  useEffect(() => {
    const meta = t.seo[page];
    if (!meta) return;
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (tag) tag.setAttribute("content", meta.desc);
    document.documentElement.lang = lang;
  }, [page, lang, t]);
  return null;
};

export default SEO;
